var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.07529 11.0663H7.65029V17.0663C7.65029 18.4663 8.40862 18.7496 9.33362 17.6996L15.642 10.5329C16.417 9.65792 16.092 8.93292 14.917 8.93292H12.342V2.93292C12.342 1.53292 11.5836 1.24959 10.6586 2.29959L4.35029 9.46626C3.58362 10.3496 3.90862 11.0663 5.07529 11.0663Z",
    stroke: "#31415F",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/flash.03a7c7fdc93d86fd4fc4dd87ef240ca9.svg";
export { ForwardRef as ReactComponent };